module.exports = __webpack_public_path__ + "static/img/faq_banner.7e1b443d.png";